import { render, staticRenderFns } from "./chat-room-pinned-popup.html?vue&type=template&id=b4e24cd6&scoped=true&external"
import script from "./chat-room-pinned-popup.js?vue&type=script&lang=js&external"
export * from "./chat-room-pinned-popup.js?vue&type=script&lang=js&external"
import style0 from "./chat-room-pinned-popup.scss?vue&type=style&index=0&id=b4e24cd6&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e24cd6",
  null
  
)

export default component.exports